import React, { useState } from 'react';
import '../SiteActivity/SiteActivity.scss';
import wallet from "../../../src/Assets/wallet.png";
import OverviewCardsSection from '../../Components/OverviewCardsSection/OverviewCardsSection';
import DataTableSection from '../../Components/DataTableSection/DataTableSection';

export default function SiteActivity() {
  const [open, setOpen] = useState(null);


  const overviewStats = [
    { title: "Total Orders", value: "75", change: "+25 (30 days)", icon: "📦" },
    { title: "Progress", value: "357", change: "+65 (30 days)", icon: "📈" },
    { title: "Total Canceled", value: "456", change: "+25 (30 days)", icon: "❌" },
    { title: "Total Completed", value: "93178", change: "+25 (30 days)", icon: "✅" }
  ];


  const activityStats = [
    { title: "Total Clients", value: "5,423", trend: "18% this month", icon: "👥" },
    { title: "Members", value: "1,893", trend: "-8% this month", icon: "👤" },
    { title: "New Clients", value: "142", trend: "-5% this month", icon: "🆕" },
    { title: "Active Now", value: "189", trend: "", icon: "💻" }
  ];

  const orders = [
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "New"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "New"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "New"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "On Process"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "On Process"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "Late order"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "On Process"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "On Process"
    }
  ];

  const recentPayouts = [
    { type: "Credit Card", date: "11/02/2022", amount: "$129.95" },
    { type: "from wallet", date: "11/02/2022", amount: "$129.95" },
    { type: "from wallet", date: "11/02/2022", amount: "$129.95" },
    { type: "Declined", date: "11/02/2022", amount: "$129.95" },
    { type: "Declined", date: "11/02/2022", amount: "$129.95" }
  ];

  return (
    <div className="site-activity-container">

      <OverviewCardsSection/>
      <DataTableSection/>

      <div className="content-wrapper   mt-3">
        <div className="orders-section">
          <div className="orders-table">
            <div className="full-width-table">
              <table>
                <thead >
                  <tr>
                    <th><input type="checkbox" /></th>
                    <th>Order ID</th>
                    <th>Client Name</th>
                    <th className="product-header" onClick={() => setOpen(open === "Product" ? null : "Product")}>
                      Product
                      <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {open === "Product" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Products</li>
                            <li>Social media</li>
                            <li>E-marketing</li>
                          </ul>
                        </div>
                      )}
                    </th>
                    <th>Date</th>
                    <th>Order time</th>
                    <th>Amount</th>
               
                       <th className="product-header" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                      Status
                      <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {open === "Status" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Products</li>
                            <li>Social media</li>
                            <li>E-marketing</li>
                          </ul>
                        </div>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, idx) => (
                    <tr key={idx}>
                      <td><input type="checkbox" /></td>
                      <td className="order-id">{order.id}</td>
                      <td className="color-gr">{order.client}</td>
                      <td>{order.product}</td>
                      <td>{order.date}</td>
                      <td>{order.time}</td>
                      <td>{order.amount}</td>
                      <td>
                        <span className={`statuss ${order.status.toLowerCase().replace(/\s+/g, '')}`}>
                          {order.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="table-footer">
                <div className="showing-info">
                  Showing 17 of 100
                </div>
                <div className="pagination">
                  <button className="active">1</button>
                  <button>2</button>
                  <button>3</button>
                  <button>4</button>
                  <button>5</button>
                  <button>Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>

     
        <div className="recent-payouts">
          <div className="card">
            <div className="card-header">
              <h3>Recent Payouts</h3>
              <button className="export-btn">Export</button>
            </div>
            <div className="card-body">
              {recentPayouts.map((payout, index) => (
                <div key={index} className="payout-item">
                  <div className="payout-info">
                    <img src={wallet} alt="" className="payout-icon" />
                    <div className="payout-details">
                      <h6>{payout.type}</h6>
                      <span>{payout.date}</span>
                    </div>
                    <div className="payout-amount">
                      <h6>{payout.amount}</h6>
                      <button className="btn-details">Details</button>
                    </div>
                  </div>
                </div>
              ))}
              <div className="payout-pagination">
                <span>Page 1 of 6</span>
                <div className="pagination-controls">
                  <button className="prev-btn">←</button>
                  <button className="next-btn">→</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 